import _ from "underscore";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import AdvancedComboboxContent from "./advanced-combobox-content";
import Loading from "../elements/loading";

const OrgPicker = props => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState(props.orgs);

  useEffect(() => {
    if (searchText !== "") {
      const results = props.orgs.filter(org => {
        return (
          org.label.toLowerCase().includes(searchText.toLowerCase()) ||
          org.value
            .toString()
            .toLowerCase()
            .includes(searchText) ||
          org.slug.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setSearchResults(results);
    } else {
      setSearchResults(props.orgs);
    }
  }, [props.orgs, searchText]);

  return (
    <div className="org-picker">
      {props.loading ? <Loading /> : null}
      {_.isEmpty(props.orgs) ? (
        <div className="org-picker--empty">You do not have access to any EverTrue organizations.</div>
      ) : (
        <div className="org-picker--full-height">
          <div className="org-picker--header">Select an Organization</div>
          <div className="org-picker--body">
            <div className="org-picker--selector">
              <AdvancedComboboxContent
                options={searchResults}
                onSearch={searchText => {
                  setSearchText(searchText);
                }}
                searchable
                focusOnMount
                onChange={val => props.handleChange(val)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

OrgPicker.propTypes = {
  orgs: PropTypes.array,
  loading: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default OrgPicker;
